module.exports = __webpack_public_path__ + "img/44320343000109.8f56757a.png";